'use client'

import { useState } from 'react'

import { ProductBadgeProps } from '../../../types/products'
import Badge from '../../Badge'

import styles from './ProductCardBadgesList.module.scss'

interface ProductCardBadgesListProps {
  badges: ProductBadgeProps[]
  rootCategorySlug?: string
}

const ProductCardBadgesList = ({
  badges,
  rootCategorySlug
}: ProductCardBadgesListProps) => {
  const [openBadge, setOpenBadge] = useState<string>('')

  return badges ? (
    <div className={styles.root}>
      {badges.map((badge, index) => (
        <Badge
          key={`product-badge-${index}`}
          badge={badge}
          onMouseEnter={() => setOpenBadge(badge.name)}
          onMouseLeave={() => setOpenBadge('')}
          isExpanded={openBadge === badge.name}
          rootCategorySlug={rootCategorySlug}
        />
      ))}
    </div>
  ) : null
}

export default ProductCardBadgesList
